/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Marienschule_Fulda3Inputs */

const en__field__enum_schoolname_marienschule_fulda3 = /** @type {(inputs: _Field__Enum_Schoolname_Marienschule_Fulda3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulda`)
};

const de__field__enum_schoolname_marienschule_fulda3 = /** @type {(inputs: _Field__Enum_Schoolname_Marienschule_Fulda3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marienschule`)
};

/**
* | output |
* | --- |
* | "Fulda" |
*
* @param {_Field__Enum_Schoolname_Marienschule_Fulda3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_marienschule_fulda3 = /** @type {((inputs?: _Field__Enum_Schoolname_Marienschule_Fulda3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Marienschule_Fulda3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_marienschule_fulda3(inputs)
	return de__field__enum_schoolname_marienschule_fulda3(inputs)
});
export { _field__enum_schoolname_marienschule_fulda3 as "_field__enum_schoolName_Marienschule_Fulda" }